import { ITagProps } from 'src/components/Tag';

const tagsByLabel = {
  new: { color: 'warning', children: 'Nyt' },
  cancelled: { color: 'danger', children: 'Aflyst' }
};

export const getNewsItemTag = (label: string): undefined | ITagProps => tagsByLabel[label];



// WEBPACK FOOTER //
// ./src/utils/newsUtils.ts